/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MaterialTypeFilterCriteria {
  None = 'None',
  Primary = 'Primary',
  Secondary = 'Secondary',
  Trace = 'Trace',
  PrimaryAndSecondary = 'PrimaryAndSecondary',
  All = 'All'
}
